type FullFormatter = (
  /** Значение, после парсинга */
  value: string,
  prevValue: string,
  cursor: number,
  options: {
    isFocused: boolean;
    /** Оригинальное значение, которое было введено в input */
    originalValue: string;
  }
) => { value: string; cursor: number };

type ShortFormatter = (
  /** Значение, после парсинга */
  value: string,
  prevValue: string,
  cursor: number,
  options: {
    isFocused: boolean;
    /** Оригинальное значение, которое было введено в input */
    originalValue: string;
  }
) => string;

export type Formatter = FullFormatter | ShortFormatter;

export type Parser = (value: string) => string;

export const createInputFormatter = (fn: Formatter): Formatter => fn;
export const createInputParser = (fn: Parser): Parser => fn;
